import { Inject, Injectable, LOCALE_ID, NgZone } from '@angular/core';

const scriptSource = 'https://www.gstatic.com/charts/loader.js';

@Injectable({ providedIn: 'root' })
export class GoogleChartsLoaderService {

  private scriptLoad: Promise<void>;
  private readonly packageLoads = new Map<string, Promise<void>>();

  constructor(private readonly zone: NgZone, @Inject(LOCALE_ID) private readonly localeId: string) {
  }

  public load(packageName: string): Promise<void> {
    let pending = this.packageLoads.get(packageName);

    if (pending === undefined) {
      pending = this.loadScript()
        .then(() => google.charts.load('current', { packages: [packageName], language: this.localeId }));
      this.packageLoads.set(packageName, pending);
    }

    return pending;
  }

  private loadScript(): Promise<void> {
    if (typeof google !== 'undefined' && typeof google.charts !== 'undefined') {
      return Promise.resolve();
    }

    if (this.scriptLoad === undefined) {
      this.scriptLoad = this.zone.runOutsideAngular(() => new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = scriptSource;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load the Google Charts script.'));
        document.head.appendChild(script);
      }));
    }

    return this.scriptLoad;
  }
}
